const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		loadWhenPrimaryKeyPresentOnly: true,
		resourceRegisterKey: 'jobProperties',
	},

	methods: {
		/**
		 * this function is used to handle the different kinds of errors.
		 * NOTE: if this function returns reject no error occurred (e.g., if the statusCode is 200)
		 * NOTE: if this function resolves the given context is always the original context and NOT the error handling context.
		 *
		 * @param   context             object - action perform context
		 *          {
		 *              component: ...
		 *              [action]: ...
		 *              error: {
		 *                  statusCode: <statusCode>            mixed - status code || 'clientError'
		 *                  name: <statusCode>                  string - error name
		 *                  errorCode: <statusCode>             string - error code
		 *                  message: <statusCode>               string - error message
		 *                  details: <statusCode>               string - error details
		 *                  [childErrors]: []                   [] - list of child errors
		 *              },
		 *              errorHandlingType: CONSTANTS.ERROR.HANDLING_TYPE[...]
		 *                                      int - this error handling type defines the state of error handling
		 *                                      e.g., has this error been thrown during error handling or has this error been thrown during custom error handling etc.
		 *                                      NOTE: this flag will be filled by CONSTANTS.ERROR.HANDLING_TYPE
		 *          }
		 * @returns Promise
		 */
		handleError: function(context){
			const baseError = utils.extractBaseError(context.error);
			let messageKey = false

			if(baseError.errorCode === 'SEQUELIZE_VALIDATION_ERROR'){
				messageKey = `error:jobs.properties.invalidData`
			}

			if(messageKey){
				return this.performAction(
					this.prepareAction('message', undefined, {
						messageDisplay: {
							message: messageKey
						}
					}, {
						rollbackContext: context,
						statusControllerLoadingMessage: '',
						statusControllerSavingMessage:  ''
					})
				);
			}

			context.errorUnhandled = true;
			return utils.promise.resolve(context);
		},

	}
}